import { Component, OnInit } from '@angular/core';
import { MetaService } from 'services/meta.service';

@Component({
	selector: 'ras-facility-standards-page',
	templateUrl: './facility-standards-page.component.html',
	styleUrls: ['./facility-standards-page.component.sass']
})
export class FacilityStandardsPageComponent implements OnInit {

	constructor(private metaService: MetaService) { }

	ngOnInit() {
		this.metaService.apply('facility-standards')
	}

}
